<!-- Página de Registro Mejorada -->
<!-- Para activar el tema negro, agrega la clase "dark" al contenedor o al body -->
<div class="registration-page">
    <div class="stars"></div>
    <div class="registration-content">
      <div class="flex justify-between">
        <button class="back-button text-black dark:text-white" (click)="toggleHome()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          {{'REGISTER-MAIN.BACK' | translate}}
        </button>
        <button class="back-button text-black dark:text-white" (click)="toggleLoggin()">
          {{'REGISTER-MAIN.GOLOGIN' | translate}}
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </button>
      </div>

      <div class="registration-header">
        <h1 class="registration-title text-black dark:text-white">{{'REGISTER-MAIN.TITLE' | translate}}</h1>
        <div class="title-underline"></div>
      </div>

      <div class="registration-options text-black dark:text-white">
        <button class="registration-option" (click)="register('taller')"
          [class.option-hover]="hoverTaller" (mouseenter)="hoverTaller = true" (mouseleave)="hoverTaller = false">
          <div class="option-content" (click)="goRegister()">
            <div class="option-icon-container">
              <span class="option-icon">🔧</span>
              <div class="option-icon-ring"></div>
            </div>
            <h3>Pitzon</h3>
            <p> {{'REGISTER-MAIN.PITZON-SUBTITLE' | translate}} </p>
            <div class="option-features">
              <span> {{'REGISTER-MAIN.PITZON-ITEM-1' | translate}} </span>
              <span> {{'REGISTER-MAIN.PITZON-ITEM-2' | translate}} </span>
              <span> {{'REGISTER-MAIN.PITZON-ITEM-3' | translate}} </span>
            </div>
          </div>
          <div class="option-shine"></div>
        </button>

        <button class="registration-option text-black dark:text-white" (click)="register('empresa')"
          [class.option-hover]="hoverEmpresa" (mouseenter)="hoverEmpresa = true" (mouseleave)="hoverEmpresa = false">
          <div class="option-content" (click)="goWorkshopForm()">
            <div class="option-icon-container">
              <span class="option-icon">🔧</span>
              <div class="option-icon-ring"></div>
            </div>
            <h3> {{'REGISTER-MAIN.TALLER-TITLE' | translate}} </h3>
            <p>{{'REGISTER-MAIN.TALLER-SUBTITLE' | translate}}</p>
            <div class="option-features">
              <span> {{'REGISTER-MAIN.TALLER-ITEM-1' | translate}} </span>
              <span> {{'REGISTER-MAIN.TALLER-ITEM-2' | translate}} </span>
              <span> {{'REGISTER-MAIN.TALLER-ITEM-3' | translate}} </span>
            </div>
          </div>
          <div class="option-shine"></div>
        </button>
      </div>
    </div>
  </div>
